import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step11 from './Step11-redux';

export default compose(
  withRouter,
  withNextStep
)(Step11);
